import { useQuery } from "@tanstack/react-query";
import { fetchLanguages } from "../Api/language";
import { Language } from "../Models/languageModel";

export const useLanguages = () => {
  return useQuery<Language[], Error>({
    queryKey: ["languages"],
    queryFn: () => fetchLanguages(),
  });
};
